import { IBasePickerSuggestionsProps, ITag } from '@fluentui/react';

//models
import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractConcept } from "../../../../models/Entities/Contracts/ContractConcept";
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum";
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractConceptStore from '../../../../redux/middleware/ContractConceptMiddleware';
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware';
import * as ContractAddendumStore from '../../../../redux/middleware/ContractAddendum.Middleware';

// common functions
import * as Functions from '../../../../functions/common'

//State
import { AppState } from "../../../../redux/reducers";


interface IProps {
  ContractId: number;
  referralDate: Date | undefined;
  onSelectedContractConcept: (contract: ContractConcept[]) => void;
  ContractConceptsSelected: Array<number | string | ContractConcept> | undefined;
  MultiselectEnable: boolean;
  DistinctByConceptName?: boolean;
  noteText?: string;
}

interface ConnectedProps {
  isLoading: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  isLoadingSuccessfully: boolean;
  failOnUpdating: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  Contract: Contract | undefined;
  ContractConcepts: ContractConcept[];
  Addendums: ContractAddendum[];
}

interface DispatchProps {
  GetContractById: typeof ContractStore.actionCreators.GetContractById;
  GetContractConceptById: typeof ContractConceptStore.actionCreators.GetContractConceptById;
  GetAllContractsConcept: typeof ContractConceptStore.actionCreators.GetAllContractsConcept;
  GetContractAddendumsByContractId: typeof ContractAddendumStore.actionCreators.GetContractAddendumsByContractId;
}

export type Props = IProps & ConnectedProps & DispatchProps;

/*
isLoading={false} 
isUpdating={false} 
isUpdatedSuccessfully={false} 
isLoadingSuccessfully={false} 
failOnUpdating={false} 
failOnLoading={false} 
error={undefined} 
Contract={undefined} 
ContractConcepts={[]} 
GetContractConceptById={undefined} 
GetAllContractsConcept={undefined}  
*/

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

  const auxContract = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId) || undefined;
  const contractConceptsFromContract = auxContract?.concepts || [];
  // state.ContractConcept.list es un acumulador global: se llena por id de
  // concepto (GET_BY_ID, ADD) y nunca se limpia por contrato, asi que arrastra
  // conceptos de contratos visitados antes en la sesion. Sin filtrar, esos
  // conceptos entran al selector con el contractAddendumId de OTRO contrato y
  // quedan agrupados bajo el nombre de adenda equivocado.
  const contractConceptsFromStore = (state.ContractConcept?.list || [])
    .filter((concept: ContractConcept) => concept.contractId === ownProps.ContractId);
  const combinedConceptsById = new Map<number, ContractConcept>();

  contractConceptsFromStore.forEach((concept: ContractConcept) => {
    combinedConceptsById.set(concept.id, concept);
  });

  contractConceptsFromContract.forEach((concept: ContractConcept) => {
    combinedConceptsById.set(concept.id, concept);
  });

  const combinedContractConcepts = Array.from(combinedConceptsById.values());

  return {
    isLoading: state.ContractConcept?.isLoadingAll,
    isUpdating: state.ContractConcept?.isLoadingAll,
    isUpdatedSuccessfully: state.ContractConcept?.successLoadingAll,
    isLoadingSuccessfully: state.ContractConcept?.successLoadingAll,
    failOnUpdating: state.ContractConcept?.failOnLoadingAll,
    failOnLoading: state.ContractConcept?.failOnLoadingAll,
    error: state.ContractConcept?.error,
    Contract: auxContract,
    ContractConcepts: combinedContractConcepts,
    // Las adendas ponen nombre a los grupos de la lista. El detalle del contrato
    // no las trae: las carga GetContractAddendumsByContractId.
    Addendums: auxContract?.addendums || [],
  }
};

export const mapDispatchToProps = {
    ...ContractConceptStore.actionCreators,
    ...ContractStore.actionCreators,
    ...ContractAddendumStore.actionCreators
};


